import axios from 'axios';

const install = (Vue, vm) => {
    /* const baseURL = process.env.NODE_ENV=="development" ? 'https://jcy.fansenseo.com/' : window.location.origin; */
    // 创建 axios 实例
    const requests = axios.create({
    //    baseURL: 'https://api.glzmn.com',
    //    baseURL: 'https://zmnpc.vanson888.com',
       baseURL: process.env.VUE_APP_BASE_URL,
		/* headers: {
		        //为了不进行预处理请求需要用这种格式的数据
		        'Content-Type': 'application/x-www-form-urlencoded'
		    }, */
        timeout: 60000, // 请求超时时间
    })

    // 错误处理函数
    const err = (error) => {
        if (error.response) {
            console.log(error)
        }
        return Promise.reject(error)
    }

    // request interceptor(请求拦截器)
    requests.interceptors.request.use(config => {
        if (vm.vuex_token) {
            config.headers['token'] = vm.vuex_token // 让每个请求携带自定义 token
        }
        return config
    }, err)

    // response interceptor（接收拦截器）
    requests.interceptors.response.use((response) => {
        const res = response.data;

        return res
    }, err)

    //api接口
    vm.$api.pcindex = (data={}) => requests.get('/api/index/entry',{params:data});
    vm.$api.getInit = (data={}) => requests.get('/api/common/init',{params:data});
    vm.$api.getTheme = (data={}) => requests.get('/api/index/theme',{params:data});
    vm.$api.getDuty = (data={}) => requests.get('/api/index/duty',{params:data});
    vm.$api.getCategory = (data={}) => requests.get('/api/index/category',{params:data});
    vm.$api.getArticle = (data={}) => requests.get('/api/index/article',{params:data});
    vm.$api.getDetail = (data={}) => requests.get('/api/index/detail',{params:data});

    vm.$api.get_channel_index = (data={}) => requests.get('/api/index/index',{params:data});
    vm.$api.goFeedback = (data={}) => requests.get('/api/index/get_index_typesetting',{params:data});
	vm.$api.get_channel_job_type = (data={}) => requests.get('/api/job/get_channel_job_type',{params:data});
	vm.$api.get_about_us = (data={}) => requests.get('/api/about/get_about_us',{params:data});
	vm.$api.get_company_course = (data={}) => requests.get('/api/about/get_company_course',{params:data});
	vm.$api.get_company_around = (data={}) => requests.get('/api/about/get_company_around',{params:data});
	vm.$api.get_company_honor = (data={}) => requests.get('/api/about/get_company_honor',{params:data});
	vm.$api.get_new_type = (data={}) => requests.get('/api/about/get_new_type',{params:data});
	vm.$api.get_new_list = (data={}) => requests.get('/api/about/get_new_list',{params:data});
	vm.$api.get_channel_job_type = (data={}) => requests.get('/api/job/get_channel_job_type',{params:data});
	vm.$api.get_channel_job_list = (data={}) => requests.get('/api/job/get_channel_job_list',{params:data});
	vm.$api.get_faq = (data={}) => requests.get('/api/job/get_faq',{params:data});
	vm.$api.get_leaving_msg = (data={}) => requests.get('/api/about/get_leaving_msg',{params:data});
	vm.$api.get_channel_category_list = (data={}) => requests.get('/api/category/get_channel_category_list',{params:data});
	vm.$api.get_channel_category_id_list = (data={}) => requests.get('/api/category/get_channel_category_id_list',{params:data});
	vm.$api.get_product_list = (data={}) => requests.get('/api/category/get_product_list',{params:data});
	vm.$api.get_channel_category_id_list_all = (data={}) => requests.get('/api/category/get_channel_category_id_list_all',{params:data});
	vm.$api.get_product_detail = (data={}) => requests.get('/api/category/get_product_detail',{params:data});
	vm.$api.get_channel_class_video = (data={}) => requests.get('/api/video/get_channel_class_video',{params:data});
	vm.$api.get_video_list = (data={}) => requests.get('/api/video/get_video_list',{params:data});
	vm.$api.get_video_class_all = (data={}) => requests.get('/api/video/get_video_class_all',{params:data});
	vm.$api.get_video_class_list = (data={}) => requests.get('/api/video/get_video_class_list',{params:data});
	vm.$api.get_channel_download_type = (data={}) => requests.get('/api/download/get_channel_download_type',{params:data});
	vm.$api.get_channel_download_list = (data={}) => requests.get('/api/download/get_channel_download_list',{params:data});
	vm.$api.get_download_list = (data={}) => requests.get('/api/download/get_download_list',{params:data});
    vm.$api.get_channel_tpm = (data={}) => requests.get('/api/download/get_channel_tpm',{params:data});
	vm.$api.get_channel_problem_type = (data={}) => requests.get('/api/problem/get_channel_problem_type',{params:data});
	vm.$api.get_channel_problem_list = (data={}) => requests.get('/api/problem/get_channel_problem_list',{params:data});
	vm.$api.get_people_welfare = (data={}) => requests.get('/api/people/get_people_welfare',{params:data});
	vm.$api.get_people_train = (data={}) => requests.get('/api/people/get_people_train',{params:data});
	vm.$api.get_people_around = (data={}) => requests.get('/api/people/get_people_around',{params:data});
	vm.$api.get_people_life = (data={}) => requests.get('/api/people/get_people_life',{params:data});
	vm.$api.leaving_msg = (data={}) => requests.get('/api/about/leaving_msg',{params:data});
    vm.$api.get_hot_search = (data = {}) => requests.get('/api/search/get_hot_search', {params:data})
    vm.$api.check_download_password = (data = {}) => requests.post('/api/download/check_password', data)
    vm.$api.get_oss_sign_url = (data = {}) => requests.post('/api/download/oss_sign_url', data)
    vm.$api.jump_download = (data = {}) => requests.post('/api/download/jump_download', data)

}
export default {
    install
}
